import type CSS from 'csstype';

import { extractCssStyle } from '../../utilities';

export interface OverflowStylingProps {
  overflowX?: CSS.Property.Overflow;
  overflowY?: CSS.Property.OverflowY;
  overflow?: CSS.Property.OverflowX;
}

export const OverflowStyling = (props: OverflowStylingProps) => extractCssStyle(props);
